type GtagWindow = Window & {
  gtag?: (command: "event", name: string, params?: Record<string, string | number | boolean>) => void
}

/**
 * GA4 커스텀 이벤트 전송기.
 *
 * 측정 ID 가 없거나(로컬·PR 프리뷰) 태그가 아직 안 붙은 시점에도 호출부가 조건문을
 * 달지 않아도 되게, 여기서 한 번만 방어한다.
 */
export const trackEvent = (name: string, params: Record<string, string | number | boolean> = {}) => {
  if (typeof window === "undefined") return

  const { gtag } = window as GtagWindow
  if (!gtag) return

  gtag("event", name, params)
}
